import { SeverityLevel } from '@microsoft/applicationinsights-web';
import ProductShoppingCategoryService from '../../api/services/product-shopping-category.service';
import { useAppInsightsLogger } from '../../logging';
import { selectUserFeatureSetting, selectUserPermissionSetting } from '../common';
import { AppThunk } from '../store';
import { productShoppingCategorySlice } from './product-shopping-category.slice';

const appInsightsLogger = useAppInsightsLogger();
const productShoppingCategoryService = ProductShoppingCategoryService.getInstance();

/**
 * Fetch all product shopping categories (flat list)
 */
export const getProductShoppingCategories =
  (customerId: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const feature = selectUserFeatureSetting(getState());
      const permission = selectUserPermissionSetting(getState());

      const hideShoppingCategories =
        !feature.CanViewShoppingCategories ||
        !permission.CanViewShoppingCategories ||
        permission.CanOnlyAccessCustomListProducts ||
        permission.CanOnlyAccessManagedListProducts;

      if (hideShoppingCategories) {
        dispatch(productShoppingCategorySlice.actions.setCategories([]));
        return;
      }
      dispatch(productShoppingCategorySlice.actions.setIsLoading(true));
      const { data } = await productShoppingCategoryService.getProductShoppingCategories(customerId);

      if (data.IsSuccess) {
        dispatch(productShoppingCategorySlice.actions.setCategories(data.ResultObject));
      }
    } catch (error) {
      appInsightsLogger.trackException({
        exception: error,
        severityLevel: SeverityLevel.Error,
      });
      console.error(error);
    } finally {
      dispatch(productShoppingCategorySlice.actions.setIsLoading(false));
    }
  };
